export default __webpack_public_path__ + "static/media/mediterraneandrink-wide@3x.584bbff2.jpg";